var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAmazon = function SvgAmazon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    fill: "#fff",
    rx: 15.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 0.5,
    y: 0.5,
    stroke: "#E5E5E5",
    rx: 15.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 4h24v24H4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F90",
    d: "M22.789 22.632c-7.657 3.732-12.408.61-15.45-1.287-.188-.12-.508.028-.23.354 1.013 1.259 4.334 4.292 8.668 4.292 4.338 0 6.918-2.424 7.24-2.847.32-.42.096-.65-.228-.512m2.149-1.216c-.206-.275-1.25-.326-1.908-.243-.658.08-1.647.493-1.56.74.043.093.133.051.586.01.453-.047 1.724-.211 1.989.143.266.357-.406 2.058-.528 2.332-.12.274.045.345.267.162.22-.182.617-.655.884-1.324.264-.673.426-1.612.27-1.82"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M17.64 15.016c0 .98.025 1.796-.459 2.666-.39.707-1.007 1.142-1.698 1.142-.942 0-1.49-.735-1.49-1.82 0-2.143 1.873-2.532 3.648-2.532zm2.475 6.127a.5.5 0 0 1-.58.06c-.814-.693-.96-1.014-1.408-1.675-1.346 1.407-2.299 1.827-4.045 1.827-2.064 0-3.672-1.304-3.672-3.917 0-2.04 1.08-3.43 2.616-4.108 1.332-.601 3.192-.707 4.615-.873v-.325c0-.598.044-1.305-.297-1.821-.3-.463-.874-.654-1.378-.654-.935 0-1.77.491-1.974 1.51-.04.226-.203.448-.424.46l-2.382-.262c-.2-.047-.42-.213-.366-.527.55-2.956 3.155-3.847 5.488-3.847 1.194 0 2.754.325 3.697 1.252 1.194 1.142 1.08 2.665 1.08 4.323v3.918c0 1.177.476 1.693.925 2.33.16.226.193.498-.007.668-.5.427-1.39 1.223-1.88 1.668z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F90",
    d: "M22.789 22.632c-7.657 3.732-12.408.61-15.45-1.287-.188-.12-.508.028-.23.354 1.013 1.259 4.334 4.292 8.668 4.292 4.338 0 6.918-2.424 7.24-2.847.32-.42.096-.65-.228-.512m2.149-1.216c-.206-.275-1.25-.326-1.908-.243-.658.08-1.647.493-1.56.74.043.093.133.051.586.01.453-.047 1.724-.211 1.989.143.266.357-.406 2.058-.528 2.332-.12.274.045.345.267.162.22-.182.617-.655.884-1.324.264-.673.426-1.612.27-1.82"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M17.64 15.016c0 .98.025 1.796-.459 2.666-.39.707-1.007 1.142-1.698 1.142-.942 0-1.49-.735-1.49-1.82 0-2.143 1.873-2.532 3.648-2.532zm2.475 6.127a.5.5 0 0 1-.58.06c-.814-.693-.96-1.014-1.408-1.675-1.346 1.407-2.299 1.827-4.045 1.827-2.064 0-3.672-1.304-3.672-3.917 0-2.04 1.08-3.43 2.616-4.108 1.332-.601 3.192-.707 4.615-.873v-.325c0-.598.044-1.305-.297-1.821-.3-.463-.874-.654-1.378-.654-.935 0-1.77.491-1.974 1.51-.04.226-.203.448-.424.46l-2.382-.262c-.2-.047-.42-.213-.366-.527.55-2.956 3.155-3.847 5.488-3.847 1.194 0 2.754.325 3.697 1.252 1.194 1.142 1.08 2.665 1.08 4.323v3.918c0 1.177.476 1.693.925 2.33.16.226.193.498-.007.668-.5.427-1.39 1.223-1.88 1.668z",
    clipRule: "evenodd"
  })));
};
export default SvgAmazon;